import React, { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Quality.css";
import { host } from "../../../../../utils";
import InputBar from "../InputBar/InputBar";
import { useSelector } from "react-redux";
import Button from "@restart/ui/esm/Button";
import { Defects, DefectsDistributionChart } from "../operatorScreen/Defects";

const Quality = (props) => {
  toast.configure();

  let selectedPlant = useSelector((state) => state.saveSelectedPlant);
  let selectedMachine = useSelector((state) => state.saveSelectedMachine);
  let selectedShift = useSelector((state) => state.saveSelectedShift);
  let selectedShiftDate = useSelector((state) => state.saveSelectedShiftDate);

  if(selectedPlant.quality){
    selectedPlant = selectedPlant.quality.selectedOption.value;
  }else{
    selectedPlant="";
  }

  if(selectedMachine.quality){
    selectedMachine = selectedMachine.quality.selectedOption.value;
  }else{
    selectedMachine="";
  }

  if(selectedShift.quality){
    selectedShift = selectedShift.quality.selectedOption.value;
  }else{
    selectedShift="";
  }

  if(selectedShiftDate.quality){
    selectedShiftDate = selectedShiftDate.quality.selectedOption.value;
  }else{
    selectedShiftDate=new Date();
  }

  const [loading, setloading] = useState(false);
  const [qualityData, setQualityData] = useState();
  const [fetchStatus, setFetchStatus] = useState(true);

  const updateData = async () => {
    let shiftDate = new Date(selectedShiftDate.getTime() + 5.5 * 3600000).toISOString().split("T")[0];
    let startTime = shiftDate + "T00:00:00.000Z";
    let endTime = shiftDate + "T23:59:59.999Z";
    setloading(true);

    axios
      .get(
        `${host}/chartserver/mindaProductionPlanAnalysis?clubbedOperatorWindows=false&startTime=${startTime}&endTime=${endTime}&plantId=${selectedPlant}&machineId=${selectedMachine}&shift=${selectedShift}`
      )
      .then(function (data) {
        setQualityData(data.data);
        setloading(false);
      })
      .catch(() => {
        setloading(false);
      });
  };

  useEffect(() => {
    updateData();
  }, [fetchStatus]);

  let tableRows;
  if (qualityData) {
    if(qualityData.associatedProdPlans){
      tableRows = qualityData.associatedProdPlans.map((plan) => {
        return (
          <QualityTableRow key={plan.planningId} plan={plan}></QualityTableRow>
        );
      });
    }
  }

  return (
    <>
    <div className="box box-default">
      <div className="box-header">
          <InputBar
              setData={setQualityData}
              setFetchStatus={setFetchStatus}
              fetchStatus={fetchStatus}
              loading={loading}
              InsIden={"quality"}
              machineType={true}
              line={true}
              machine={true}
              shift={true}
              shiftDate={true}
            ></InputBar>
      </div>
      <div className="box-body">
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Production Id</th>
            <th>Part Id</th>
            <th>Machine</th>
            <th>Line</th>
            <th>Quantity Planned</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Actual Shots</th>
            <th>NG Quantity</th>
            <th>OK Quantity</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </Table>
      </div>
    </div>
    </>
  );
};

const QualityTableRow = (props) => {
  const [showDefects, setShowDefects] = useState(false);
  const [show, setShow] = useState(false);
  const closeGraph = () => setShow(false);

  const onClickAdd = (planIdClicked) => {
    setShowDefects(true);
  };

  const totalDefectsClick = (data) => {
    setShow(true);
  };

  return (
    <>
      <tr>
        <td>{props.plan.planningId}</td>
        <td>{props.plan.partId}</td>
        <td>{props.plan.machineInfo.machineName}</td>
        <td>{props.plan.lineId}</td>
        <td>{props.plan.quantityPlanned}</td>
        <td>{props.plan.startDate}</td>
        <td>{props.plan.endDate}</td>
        <td>{props.plan.actualProduction}</td>
        <td
          type="button"
          onClick={() => {
            totalDefectsClick(props.plan);
          }}
        >
          <strong>{props.plan.totalDefects+"    "}</strong>
        </td>
        <td>{props.plan.actualProduction - props.plan.totalDefects}</td>
        <td>
          <Button
            className="btn btn-info w-100"
            onClick={() => {
              onClickAdd(props.plan.planningId);
            }}
          >
            Add
          </Button>
        </td>
      </tr>
      <Defects
        showDefects={showDefects}
        setShowDefects={setShowDefects}
        planningId={props.plan.planningId}
        actualProduction={props.plan.actualProduction}
      />
      <>
        <Modal show={show} onHide={closeGraph}>
          <Modal.Header closeButton>
            <Modal.Title>Defects Distribution</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DefectsDistributionChart
              defectDistribution={
                props.plan["qualityInspectionAnalyticsManual"][
                  "defectDistribution"
                ]
              }
            ></DefectsDistributionChart>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </>
    </>
  );
};

export default Quality;
